export const configuration = {
  "issuer": 'https://espace-client.obexto.fr/auth/v1',
  "tokenEndpoint": 'https://espace-client.obexto.fr/auth/v1/connect/token',
  "userinfoEndpoint": 'https://espace-client.obexto.fr/auth/v1/connect/userinfo',
  "dummyClientSecret": 'ivSfaLUshT8ASrvR8Eht3axZv60aM2ub',
  "companyName" : "Obexto",
  "firstColor" : "#f47822",// todo
  "secondColor" : "#127fba",// todo
  "logo" : "logoObexto.png", //image re rapport 5/1 de 250px de large minimum. ex : 300*60px 
  "commandes":
  {
    "labels" : 
    {
      "totalWork" : "Temps prévu",
      "remainingWork": "Temps",
    }
  },
  "pageHeaders" : 
  {
    "pointage" : "TODO add text for pointage",
    "factures" : "TODO add text for factures",
    "appelASupport" : "TODO add text for appelASupport",
    "commandes" : "TODO add text for commandes",
    "home" : "<div style=\"font-style: italic;\">TODO add text for home test div with italic CSS</div>",
  },
  "appelASupport":
  {
    "enumEtatAvancement" : 
    { //si un label contient le terme "A valider", ce dernier sera afficher en warning (rouge clignotant)
      "CREA": "créé",
      "RCPT": "récéptionné par Obexto",
      "DEMD_VALI_CLI": "en attente de validation",
      "DEB_TRMT":"début de traitement par Obexto",
      "FIN_TRMT":"fin de traitement par Obexto",
      "VALI_TRMT":"traité par Obexto. A valider", 
      "CLOT" : "cloturé"
    }
  }
};